import {LoanApplication} from '../../../../model/loan-application.model';

export class ActiveApplicationTile {
    readonly application?: LoanApplication;
    readonly status: string;
    readonly action: string;
    readonly redirectRoute: string;
    readonly nonRetail?: boolean;
    readonly loanSuggestedTermAction?: string;
    readonly loanSuggestedTermRoute?: string;

    constructor(status: string, action: string, redirectRoute: string, application?: LoanApplication, nonRetail?: boolean, loanSuggestedTermAction?: string, loanSuggestedTermRoute?: string) {
        this.status = status;
        this.action = action;
        this.redirectRoute = redirectRoute;
        this.application = application;
        this.nonRetail = nonRetail;
        this.loanSuggestedTermAction = loanSuggestedTermAction;
        this.loanSuggestedTermRoute = loanSuggestedTermRoute;
    }
}


export class LoanTile {
    readonly generatedLoanId: string;
    readonly reason: string;
    readonly amount: number;
    readonly roi: number;
    readonly tenure: number;
    readonly applicationDate: Date;
    readonly status: string;
    readonly redirection?: {label: string; link?: string};
    readonly colorCode?: string;


    constructor(generatedLoanId: string, reason: string, amount: number, roi: number, tenure: number, applicationDate: Date,
                status: string, redirection?: { label: string; link?: string }, colorCode?: string) {
        this.generatedLoanId = generatedLoanId;
        this.reason = reason;
        this.amount = amount;
        this.roi = roi;
        this.tenure = tenure;
        this.applicationDate = applicationDate;
        this.status = status;
        this.redirection = redirection;
        this.colorCode = colorCode;
    }
}
